import {
  APPLICANT_DETAILS_PATCH,
  APPLICANT_DETAILS_SUBMIT,
  COMPANY_ADDRESS_SUBMIT,
  COMPANY_DETAILS_SUBMIT,
  DELETE_DOCUMENT,
  DELETE_REPRESENTATIVE,
  PEOPLE_INFORMATION_KYC_SUBMIT,
  UPLOAD_DOC_SUCCESS,
  USER_DOCUMENTS_INFO
} from '../../action-contants';
import { getNextScreen, mergeObjectArray, mergeArraysByParameter } from '../../../utils/library';
import { ENTITY_TYPE_REPRESENTATIVE, REPRESENTATIVE_TYPES } from '../../../utils/constants';
import { API_URL, REQ_TIMEOUT } from '../../../utils/config';
import { remitterPersonalInfo } from '../user-status/user-status-action';
import { handleError, showMessage } from '../common-message/message-action';
import {
  getAccountType,
  getNextScreenFromState,
  getRemitterAccountTypeId,
  makeApiCall
} from '../common/common-action';

export function applicantDetailsSubmit(data) {
  return {
    type: APPLICANT_DETAILS_SUBMIT,
    data
  };
}

function applicantDetailsPatch(data) {
  return {
    type: APPLICANT_DETAILS_PATCH,
    data
  };
}

function UserDocumentsInfo(data) {
  return {
    type: USER_DOCUMENTS_INFO,
    data
  };
}

function companyAddressSubmit(data) {
  return {
    type: COMPANY_ADDRESS_SUBMIT,
    data
  };
}

function companyDetailsSubmit(data) {
  return {
    type: COMPANY_DETAILS_SUBMIT,
    data
  };
}

function peopleInfoKycSubmit(data) {
  return {
    type: PEOPLE_INFORMATION_KYC_SUBMIT,
    data
  };
}

function deleteRepresentative(data) {
  return {
    type: DELETE_REPRESENTATIVE,
    data
  };
}

function deleteDocument(data) {
  return {
    type: DELETE_DOCUMENT,
    data
  };
}

function uploadDocSuccess(data) {
  return {
    type: UPLOAD_DOC_SUCCESS,
    data
  };
}
function setAddressStreet(countryCode, formData) {
  const form_data = { ...formData };
  if (countryCode === 'US' || countryCode === 'AU') {
    if (form_data.street_name === null) {
      form_data.street_name = form_data.street;
    }
    if (form_data.street_type === null) {
      form_data.street_type = form_data.street;
    }
  }
  return form_data;
}
function setStreetNameType(street, formData) {
  const form_data = { ...formData };
  form_data.street_name = street;
  return form_data;
}

function getFormDataPayload(
  { formData, documents, files, additionalData, dispatch },
  skipScreenName
) {
  let formDetails;
  const payloadObj = new FormData();
  if (!skipScreenName) {
    const next_screen = dispatch(getNextScreenFromState());
    formDetails = { ...formData, screen_name: next_screen };
    payloadObj.append('screen_name', next_screen);
  }
  payloadObj.append('documents', JSON.stringify(documents));
  Object.keys(files).forEach((fileName) => {
    const extension = files[fileName].name
      ? files[fileName].name
      : `${fileName}.${files[fileName].type.split('/')[1]}`;
    payloadObj.append(fileName, files[fileName], extension);
  });
  Object.keys({ ...formData, ...additionalData }).forEach((key) => {
    if (key === 'other_countries_of_business' || key === 'additional_info') {
      payloadObj.append(key, JSON.stringify(formData[key]));
    } else if (formData[key]) {
      payloadObj.append(key, formData[key]);
    }
  });
  return {
    formDetails,
    formFileDetails: payloadObj
  };
}

export function applicantDetailsSubmitRequest(formData, requiredObj) {
  const { applicant_id, documents, files } = requiredObj;
  return async (dispatch, getState) => {
    try {
      const initialFormData = { ...formData };
      /**
       * Changed by Krunal
       * Change for Address API issue
       */
      const { country_code } = getState().rootReducer.userStatusReducer;
      const { disable_fields } = getState().rootReducer.userDataReducer.userAddressInfo;
      if (!disable_fields) {
        formData = setAddressStreet(country_code, formData);
      } else if (disable_fields && !formData.street_name && !formData.street_type) {
        formData = setStreetNameType(formData.street, formData);
      }
      delete formData.initData;
      delete formData.mobile_otp;
      delete formData.street;
      const representative_types = REPRESENTATIVE_TYPES.filter((value) => formData[value] === true);
      REPRESENTATIVE_TYPES.forEach((key) => delete formData[key]);
      formData.representative_types = representative_types;
      const { formFileDetails, formDetails } = getFormDataPayload({
        formData,
        documents,
        files,
        dispatch
      });
      //if upload_doc_later_check is unchecked then only authorized to upload file
      let method,
        response_data,
        url,
        is_representative = false;
      if (applicant_id) {
        method = 'patch';
        url = `${API_URL}/remitter/corporate/applicant-details/${applicant_id}`;
      } else {
        method = 'post';
        url = `${API_URL}/remitter/corporate/applicant-details`;
      }
      const response = await makeApiCall({
        method,
        url,
        withCredentials: true,
        data: formFileDetails,
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        const apiRespData = response.data.data;
        //we dont need document details in applicant details,
        is_representative = apiRespData.authorityList && apiRespData.authorityList.length > 1;
        if (method === 'post') {
          response_data = {
            // SAVE FORM DATA ON RESPONSE IN APPLICANT DETAILS
            ...initialFormData,
            ...formDetails,
            account_type_id: apiRespData.account_type_id,
            remitter_corporate_representative_id: apiRespData.remitter_corporate_representative_id,
            authorityList: apiRespData.authorityList
          };
          dispatch(applicantDetailsSubmit({ ...response_data, is_representative }));
          dispatch(peopleInfoKycSubmit({ ...response_data }));
        } else if (method === 'patch') {
          response_data = {
            // SAVE FORM DATA ON RESPONSE IN APPLICANT DETAILS
            ...initialFormData,
            ...formDetails,
            remitter_corporate_representative_id: apiRespData.remitter_corporate_representative_id,
            authorityList: apiRespData.authorityList
          };

          dispatch(applicantDetailsPatch({ ...response_data, is_representative }));
          dispatch(peopleInfoKycSubmit({ ...response_data }));
        }
        dispatch(
          uploadDocSuccess(
            mergeArraysByParameter(documents, response.data.data.documents, 'fieldname')
          )
        );
        dispatch(remitterPersonalInfo());
      } else dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      return response;
    } catch (err) {
      dispatch(handleError(err));
      const { response } = err;
      return response || err;
    }
  };
}

export function companyAddressSubmitRequest(props, documents) {
  return async (dispatch, getState) => {
    try {
      const state = getState(),
        screen_name = getNextScreen(
          state.rootReducer.userFlowReducer.screens,
          state.rootReducer.userFlowReducer.currentScreen
        );
      let postData = { ...props, screen_name };
      /**
       * Changed by Krunal
       * Change for Address API issue
       */
      const { country_code } = getState().rootReducer.userStatusReducer;
      const { disable_fields } = getState().rootReducer.userDataReducer.userAddressInfo;
      if (!disable_fields) {
        postData = setAddressStreet(country_code, postData);
      } else if (disable_fields && !postData.street_name && !postData.street_type) {
        postData = setStreetNameType(postData.street, postData);
      }
      delete postData.initData;
      delete postData.street;
      if (postData.incorporation && postData.incorporation.street)
        delete postData.incorporation.street;

      // for address of incorporation
      const same = postData.is_business_address_same_as_incorporation_address;
      Object.keys(same ? postData.incorporation : postData).forEach(
        (key) =>
          !['incorporation', 'screen_name'].includes(key) &&
          (postData['incorporation_' + key] = same ? postData.incorporation[key] : postData[key])
      );
      postData.is_business_address_same_as_incorporation_address =
        !postData.is_business_address_same_as_incorporation_address;
      delete postData.incorporation;

      /**
       * Changes done by krunal
       * As incorporation streetname and streettype are coming null
       * It is set to what user types in from street_name and street_type
       */
      if (!postData.incorporation_street_name)
        postData.incorporation_street_name = postData.street_name;
      if (!postData.incorporation_street_type)
        postData.incorporation_street_type = postData.street_type;
      delete postData.incorporation_incorporation_countries_of_operations;
      delete postData.main_countries_of_operations;
      delete postData.incorporation_main_countries_of_operations;
      postData.incorporation_countries_of_operations = JSON.stringify(
        postData?.incorporation_countries_of_operations
      );

      const formData = new FormData();

      const account_type = dispatch(getAccountType());
      const account_type_id = dispatch(getRemitterAccountTypeId());
      formData.append('remitter_' + account_type.toLowerCase() + '_id', account_type_id);

      Object.entries(postData).forEach(([key, value]) => value && formData.append(key, value));
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/corporate/company-address`,
        withCredentials: true,
        data: formData,
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        dispatch(companyAddressSubmit(postData));
        const mergedDocArray = mergeObjectArray(
          documents,
          response.data.data.documents,
          'document_field_name'
        );
        dispatch(UserDocumentsInfo(mergedDocArray));
        return response;
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
    } catch (err) {
      dispatch(handleError(err));
      const { response } = err;
      return response || err;
    }
  };
}

export function companyDetailsSubmitRequest(props, { files, documents }) {
  return async (dispatch) => {
    try {
      const payloadObj = new FormData();
      payloadObj.append('documents', JSON.stringify(documents));
      Object.keys(files).forEach((fileName) => {
        const extension = files[fileName].name
          ? files[fileName].name
          : `${fileName}.${files[fileName].type.split('/')[1]}`;
        payloadObj.append(fileName, files[fileName], extension);
      });
      const next_screen = dispatch(getNextScreenFromState());
      const formDetails = { ...props, screen_name: next_screen };
      const account_type_id = dispatch(getRemitterAccountTypeId());
      payloadObj.append('remitter_corporate_id', account_type_id);
      payloadObj.append('screen_name', next_screen);
      Object.keys(props).forEach((key) => {
        if (key === 'other_countries_of_business' || key === 'additional_info') {
          if (key === 'other_countries_of_business' && props[key]) {
            props[key] = props[key].map((val) => {
              return val.value;
            });
          }
          payloadObj.append(key, JSON.stringify(props[key]));
        } else if (props[key]) {
          payloadObj.append(key, props[key]);
        }
      });
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/corporate/company-details`,
        withCredentials: true,
        data: payloadObj,
        timeout: REQ_TIMEOUT
      });
      if (response && response.data && response.data.success) {
        dispatch(companyDetailsSubmit(formDetails));
        dispatch(
          uploadDocSuccess(
            mergeArraysByParameter(documents, response.data.data.documents, 'fieldname')
          )
        );
      } else {
        dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      }
      return response;
    } catch (err) {
      dispatch(handleError(err));
      return err;
    }
  };
}

//Company Documents
export function companyDocsSubmitRequest({ documents, files }) {
  return async (dispatch) => {
    try {
      const { formFileDetails } = getFormDataPayload(
        { formData: {}, documents, files, dispatch },
        true
      );
      //append file and form fields
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/remitter/corporate/company-documents`, //need to fix
        withCredentials: true,
        data: formFileDetails,
        timeout: REQ_TIMEOUT
      });
      if (response && response.data && response.data.success) {
        const respData = response.data.data;
        if (respData.documents && respData.documents.length > 0) {
          dispatch(
            uploadDocSuccess(
              mergeArraysByParameter(documents, response.data.data.documents, 'fieldname')
            )
          );
        }
        return response;
      } else dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
    } catch (err) {
      dispatch(handleError(err));
      const { response } = err;
      return response || err;
    }
  };
}

export function businessProfileSubmitRequest(payload) {
  return async (dispatch) => {
    const next_screen = dispatch(getNextScreenFromState());
    const account_type_id = dispatch(getRemitterAccountTypeId());
    payload['remitter_corporate_id'] = account_type_id;
    payload['screen_name'] = next_screen;

    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/corporate/business-profile`,
        withCredentials: true,
        data: payload,
        timeout: REQ_TIMEOUT
      });
      if (response && response.data && response.data.success) {
        return response;
      } else dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
    } catch (err) {
      dispatch(handleError(err));
      const { response } = err;
      return response || err;
    }
  };
}

//Authorities List
export function peopleKYCSubmitRequest(formData, requiredObj) {
  const { representative_id, documents, files } = requiredObj;
  return async (dispatch, getState) => {
    try {
      delete formData.initData;
      delete formData.identity_doc_type;
      delete formData.addr_doc_type;
      /**
       * Changed by Krunal
       * Change for Address API issue
       */
      const { country_code } = getState().rootReducer.userStatusReducer;
      const { disable_fields } = getState().rootReducer.userDataReducer.userAddressInfo;
      if (!disable_fields) {
        formData = setAddressStreet(country_code, formData);
      } else if (disable_fields && !formData.street_name && !formData.street_type) {
        formData = setStreetNameType(formData.street, formData);
      }
      delete formData.street;
      const initialFormData = { ...formData };
      const representative_types = REPRESENTATIVE_TYPES.filter((value) => formData[value] === true);
      REPRESENTATIVE_TYPES.forEach((key) => delete formData[key]);
      formData.representative_types = representative_types;
      const { formFileDetails, formDetails } = getFormDataPayload(
        { formData, documents, files, dispatch },
        true
      );
      //if upload_doc_later_check is unchecked then only authorized to upload file
      let method, url, response_data;
      if (representative_id) {
        method = 'patch';
        url = `${API_URL}/remitter/corporate/company-representative-details/${representative_id}`;
      } else {
        method = 'post';
        url = `${API_URL}/remitter/corporate/company-representative-details`;
      }
      const response = await makeApiCall({
        method: method,
        url: url,
        withCredentials: true,
        data: formFileDetails,
        timeout: REQ_TIMEOUT
      });
      if (!response) return { message: 'no response' };
      if (response && response.data && response.data.success) {
        const apiRespData = response.data.data;
        const responseRepresentativeId = apiRespData.remitter_corporate_representative_id;
        //we donot need document details in applicant details,
        response_data = {
          //...getstate SAVE FORM DATA ON RESPONSE IN APPLICANT DETAILS
          ...initialFormData,
          ...formDetails,
          remitter_corporate_representative_id: responseRepresentativeId,
          authorityList: apiRespData.authorityList
        };
        dispatch(peopleInfoKycSubmit(response_data));
        dispatch(
          uploadDocSuccess(
            mergeArraysByParameter(documents, response.data.data.documents, 'fieldname')
          )
        );
        return response;
      } else dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
    } catch (err) {
      dispatch(handleError(err));
      const { response } = err;
      return response || err;
    }
  };
}

export function authoritiesDeleteRequest(representative_id) {
  return async (dispatch) => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/corporate/company-representative-details/${representative_id}`,
        withCredentials: true,
        timeout: REQ_TIMEOUT
      });
      if (response && response.data && response.data.success) {
        //we donot need document details in applicant details,
        //dispatch todo
        dispatch(deleteRepresentative({ representative_id: representative_id }));
        dispatch(
          deleteDocument({
            entity_id: representative_id,
            entity_type: ENTITY_TYPE_REPRESENTATIVE
          })
        );
      } else dispatch(showMessage({ text: [response.data.data.message], type: 'error' }));
      return response;
    } catch (err) {
      dispatch(handleError(err));
      const { response } = err;
      return response || err;
    }
  };
}

export function authoritiesSubmitRequest() {
  return async (dispatch) => {
    try {
      const screen_name = dispatch(getNextScreenFromState());
      return await makeApiCall({
        method: 'post',
        url: `${API_URL}/remitter/corporate/acknowledge`,
        withCredentials: true,
        data: { screen_name },
        timeout: REQ_TIMEOUT
      });
    } catch (err) {
      dispatch(handleError(err));
      const { response } = err;
      return response || err;
    }
  };
}

export function getCompanyRepresentativeTypes(is_applicant) {
  return async (dispatch) => {
    try {
      return await makeApiCall({
        method: 'get',
        url: `${API_URL}/remitter/corporate/company-representative-types`,
        withCredentials: true,
        params: { is_applicant },
        timeout: REQ_TIMEOUT
      });
    } catch (err) {
      dispatch(handleError(err));
      const { response } = err;
      return response || err;
    }
  };
}
